// Masifi (plan R1 Tarea 5, R1-RD/RP-7): en una marca que no es la instancia, los links a la documentación de Chatwoot
// (literales en componentes calientes de upstream: Captain, WhatsApp, Campañas) se ocultan por CSS y window.open no
// los abre. Sin tocar core: lo instala el overlay de textos del dashboard (dashboard/i18n/masifi/index.js), que corre en
// el dashboard y en el login. Solo patrones de documentación: un link de un contacto a chatwoot.com no se oculta.
// EXCEPCIÓN REGISTRADA a la regla 6 (G-I6; /root/docs/ui-standards.md § B.1): inyecta un <style> GLOBAL y envuelve
// window.open. Why: los links viven en .vue calientes de upstream sin seam (tocarlos = touchpoints nuevos); es un .js,
// así que masifiUiStandards.spec.js (solo .vue) no lo mide → lo vigila la probe :brand_link_guard (Masifi::Customizations).
export const BLOCKED_LINK_PATTERNS = [
  'chwt.app',
  'chatwoot.com/docs',
  'chatwoot.com/hc',
  'chatwoot.com/features',
  'chatwoot.com/pricing',
];
// Id neutro: el <style> queda en el DOM de un dominio de marca (R1-RN, Tarea 11).
const STYLE_ID = 'help-link-guard';

export const isBlockedHelpUrl = url =>
  typeof url === 'string' &&
  BLOCKED_LINK_PATTERNS.some(pattern => url.includes(pattern));

export const linkGuardCss = () =>
  `${BLOCKED_LINK_PATTERNS.map(pattern => `a[href*="${pattern}"]`).join(',')}{display:none}`;

export const installMasifiLinkGuard = (
  globalConfig,
  doc = globalThis.document,
  win = globalThis.window
) => {
  const kind = globalConfig?.BRAND_KIND;
  if (!doc || !win || !kind || kind === 'instance') return false;
  if (doc.getElementById(STYLE_ID)) return true;

  const style = doc.createElement('style');
  style.id = STYLE_ID;
  style.textContent = linkGuardCss();
  doc.head.appendChild(style);

  const nativeOpen = win.open.bind(win);
  win.open = (url, ...rest) =>
    isBlockedHelpUrl(String(url ?? '')) ? null : nativeOpen(url, ...rest);
  return true;
};
